import React, {useEffect, useState} from "react"

import {Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTitle from "../../components/MetaTitle"
import useCategories from "../../hooks/useCategories"
import classnames from "classnames"
import SubCategories from "./SubCategories"
import EditCategory from "./EditCategory"
import EditCategoryPhoto from "./EditCategoryPhoto"

const styles = {
    tabStyle: {
        cursor: "pointer"
    }
}

const CategoryDetails = props => {

    const {id} = props.match.params

    const {category, loadCategory, globalState} = useCategories(false)
    const [activeTab, setActiveTab] = useState(0)

    const toggle = tab => setActiveTab(tab)

    useEffect(() => loadCategory(id), [globalState.categoriesChange])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTitle title={"Categories"}/>
                <Container fluid={true}>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Details"/>

                    <Card>
                        <CardBody>
                            <h4 className="card-title mb-4">{category?.name}</h4>


                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        style={styles.tabStyle}
                                        className={classnames({
                                            active: activeTab === 0,
                                        })}
                                        onClick={() => toggle(0)}
                                    >
                                        Sub categories
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: activeTab === 1,
                                        })}
                                        onClick={() => toggle(1)}
                                    >
                                        Edit details
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: activeTab === 2,
                                        })}
                                        onClick={() => toggle(2)}
                                    >
                                        Edit male photo
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: activeTab === 3,
                                        })}
                                        onClick={() => toggle(3)}
                                    >
                                        Edit female photo
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab} className="p-3 text-muted">
                                <TabPane tabId={0}>
                                    <SubCategories category={category}/>
                                </TabPane>
                                <TabPane tabId={1}>
                                    <EditCategory category={category}/>
                                </TabPane>
                                <TabPane tabId={2}>
                                    <EditCategoryPhoto category={category} gender={"male"}/>
                                </TabPane>
                                 <TabPane tabId={3}>
                                    <EditCategoryPhoto category={category} gender={"female"}/>
                                </TabPane>
                            </TabContent>


                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default CategoryDetails
